require("!ngtemplate?relativeTo=/src/ui/modules/dc-ui/dc-modal/&prefix=modules/dc-ui/dc-modal/!raw!./windowTemplate.tpl.html");
require("!ngtemplate?relativeTo=/src/ui/modules/dc-ui/dc-modal/&prefix=modules/dc-ui/dc-modal/!raw!./windowTemplateNotification.tpl.html");
require("!ngtemplate?relativeTo=/src/ui/modules/dc-ui/dc-modal/&prefix=modules/dc-ui/dc-modal/!raw!./windowTemplateNotificationXLarge.tpl.html");
require("!ngtemplate?relativeTo=/src/ui/modules/dc-ui/dc-modal/&prefix=modules/dc-ui/dc-modal/!raw!./windowTemplateNotificationXXLarge.tpl.html");
///modules/dcb-ui/dc-modal/

export default ["$uibModal", "$uibModalStack", "$templateCache", "_", function DialogService($uibModal, $uibModalStack, $templateCache, _) {

  return {
    showPrimary: showPrimary,
    showError: showError,
    showNotification: showNotification,
    showSpecialNotifications: showSpecialNotifications,
    showDialog: showDialog,
    okCancelController: okCancelController,
    showSmallDialog: showSmallDialog,
    showDownloadDialog: showDownloadDialog,
    showXLargeDialog: showXLargeDialog,
    showStoredFilterDialog: showStoredFilterDialog,
    showStoredFilterDeleteDialog: showStoredFilterDeleteDialog,
    showAddPeriodicDownloadDialog: showAddPeriodicDownloadDialog,
    showDemoUserDialog: showDemoUserDialog,
    showFirstLoginDialog: showFirstLoginDialog,
    showWelcomeDialog: showWelcomeDialog,
    showEmailDialog: showEmailDialog,
    showVerifyContractDialog: showVerifyContractDialog,
    showAddPhoneDialog: showAddPhoneDialog,
    showConfirmChangeDialog: showConfirmChangeDialog,
    showProtectBuyTemplate: showProtectBuyTemplate,
    showKycJumpDialog: showKycJumpDialog,
    showKycSubmitDialog: showKycSubmitDialog,
    showKycAdminStatusHistoryDialog: showKycAdminStatusHistoryDialog,
    showKycAdminSubmitDialog: showKycAdminSubmitDialog,
    showInfoDialog: showInfoDialog,
    showInputDialog: showInputDialog,
    showBonusShopDialog: showBonusShopDialog,
    showSSMSDialog: showSSMSDialog,
    closeAllDialogs: closeAllDialogs
  };

  function okCancelController($scope, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

  function showDynamicDialog(message, data, saveFunction, dialog) {
    return new Promise((resolve, reject) => {
      dialog(message, data, saveFunction).result.then(() => {
        resolve();
      }, () => {
        resolve();
      });
    });
  }

  function showAdvertisingSettingsDialog(message, data, saveData) {

    var modalInstance = $uibModal.open({
      template: require("./" + _.get(message, "specialNotification.html")),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      backdrop: "static",
      keyboard: false,
      controller: ["$scope", "$uibModalInstance", "message", "data", "saveData", function ($scope, $uibModalInstance, message, data, saveData) {
        $scope.message = message;
        $scope.data = data;
        $scope.saveData = saveData;
        $scope.isMandatory = _.get(message, "specialNotification.dueDate") && moment(new Date()).diff(moment(_.get(message, "specialNotification.dueDate"))) > 0;

        $scope.advertisingSettingsSet = function () {
          return (data.emailNo || data.email) &&
            (data.mobileNo || data.mobile) &&
            (data.phoneNo || data.phone);
        };

        $scope.ok = function () {
          saveData(message, $scope.data);
          $uibModalInstance.close();
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }],
      resolve: {
        message: function () {
          return message;
        },
        data: function () {
          return data;
        },
        saveData: function () {
          return saveData;
        }
      }
    });

    return modalInstance;
  }

  function showSecurityQuestionDialog(message, data, saveData) {
    var questionPool = data.questionPool;
    var personsidentification = {};

    var modalInstance = $uibModal.open({
      template: require("./" + _.get(message, "specialNotification.html")),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      backdrop: "static",
      keyboard: false,
      controller: ["$scope", "$uibModalInstance", "message", "personsidentification", "questionPool", "saveData", function ($scope, $uibModalInstance, message, personsidentification, questionPool, saveData) {
        $scope.message = message;
        $scope.personsidentification = personsidentification;
        $scope.securityQuestionChanged = function (answer) {
          $scope.personsidentification[answer] = "";
          reduceQuestionpool();
        };
        $scope.questionPool = questionPool;
        $scope.saveData = saveData;
        $scope.isMandatory = _.get(message, "specialNotification.dueDate") && moment(new Date()).diff(moment(_.get(message, "specialNotification.dueDate"))) > 0;

        var initQuestionPool = _.cloneDeep($scope.questionPool);

        function reduceQuestionpool() {
          var choosedQuestions = [];
          choosedQuestions.push($scope.personsidentification.question1);
          choosedQuestions.push($scope.personsidentification.question2);
          choosedQuestions.push($scope.personsidentification.question3);
          choosedQuestions.push($scope.personsidentification.question4);
          $scope.questionPool = initQuestionPool.filter(x => choosedQuestions.indexOf(x) == -1);
        }

        $scope.ok = function () {
          saveData(message, $scope.personsidentification);
          $uibModalInstance.close();
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }],
      resolve: {
        message: function () {
          return message;
        },
        personsidentification: function () {
          return data.identification;
        },
        questionPool: function () {
          return data.questionPool;
        },
        saveData: function () {
          return saveData;
        }
      }
    });
    return modalInstance;
  }


  function showSpecialNotifications(messages) {
    return new Promise((resolve, reject) => {

      if (messages && messages.length > 0) {
        var dialogMapping = {
          "showSecurityQuestionDialog": showSecurityQuestionDialog,
          "showAdvertisingSettingsDialog": showAdvertisingSettingsDialog
        };

        let promises = [];
        messages.map((message) => {
          let currentMessage = _.cloneDeep(message);
          if ((currentMessage.show !== undefined ? currentMessage.show : true) && dialogMapping[currentMessage.dialog]) {
            promises.push(showDynamicDialog(currentMessage, currentMessage.data, currentMessage.saveFunction, dialogMapping[currentMessage.dialog]));
          }
          else {
            promises.push(currentMessage.skipFunction(currentMessage));
          }
        });

        Promise.all(promises).then(() => {
          resolve();
        });
      }
      else {
        resolve();
      }
    });
  }

  function showNotification(messages, totalLength, readmessage) {
    var current = 0;
    var modalInstance = $uibModal.open({
      template: require("./notificationTemplate.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      backdrop: "static",
      controller: ["$scope", "$uibModalInstance", "messages", "readmessage", "current", function ($scope, $uibModalInstance, messages, readmessage, current) {
        $scope.messages = messages;
        $scope.readmessage = readmessage;
        if (totalLength) {
          $scope.length = totalLength;
        } else {
          $scope.length = messages.length;
        }

        $scope.current = current;

        $scope.done = function (message) {
          $scope.readmessage(message);
          if ($scope.current === messages.length - 1) {
            $scope.ok();
          }
          else {
            $scope.current++;
          }
        };

        $scope.ok = function () {
          $uibModalInstance.close();
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }],
      resolve: {
        messages: function () {
          return messages;
        },
        readmessage: function () {
          return readmessage;
        },
        current: function () {
          return current;
        }
      }
    });
    return modalInstance;
  }

  function showPrimary(title, message) {
    return simpleInstance(title, message, require("./primaryTemplate.tpl.html"), "modules/dc-ui/dc-modal/windowTemplatePrimary.tpl.html");
  }

  function showError(title, message, modal) {
    return simpleInstance(title, message, require("./errorTemplate.tpl.html"), "modules/dc-ui/dc-modal/windowTemplateError.tpl.html");
  }

  function simpleInstance(title, message, template, windowTemplate, backdrop) {
    var modalInstance = $uibModal.open({
      template: template,
      windowTemplateUrl: windowTemplate,
      backdrop: backdrop,
      controller: ["$scope", "$uibModalInstance", "title", "message", "$log", function ($scope, $uibModalInstance, title, message, $log) {

        //console.log("title", title, message);
        $scope.title = title;
        $scope.message = message;

        $scope.ok = function () {
          $uibModalInstance.close();
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

        $scope.$on('$routeChangeStart', function () {
          //$log.info("close modal instance");
          $uibModalInstance.close();
        });
      }],
      resolve: {
        title: function () {
          return title;
        },
        message: function () {
          return message;
        }
      }
    });

    return modalInstance;

  }

  function showDownloadDialog(scope) {
    var modalInstance = $uibModal.open({
      template: require("./downloadDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope
    });

    return modalInstance;
  }

  function showStoredFilterDialog(scope) {
    var modalInstance = $uibModal.open({
      template: require("./storedFilterDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope
    });

    return modalInstance;
  }

  function showStoredFilterDeleteDialog(scope) {
    var modalInstance = $uibModal.open({
      template: require("./storedFilterDeleteDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope
    });

    return modalInstance;
  }

  function showSmallDialog(template, controller, resolve, scope) {

    var modalInstance = $uibModal.open({
      template: template,
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      controller: controller,
      resolve: resolve || {},
      scope: scope
    });

    return modalInstance;
  }

  function showAddPeriodicDownloadDialog(scope) {
    var modalInstance = $uibModal.open({
      template: require("./addPeriodicDownloadDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      scope: scope
    });

    return modalInstance;
  }

  function showDemoUserDialog(scope) {
    var modalInstance = $uibModal.open({
      template: require("./demoUserDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope
    });

    return modalInstance;
  }

  function showFirstLoginDialog(scope, user) {
    var modalInstance = $uibModal.open({
      template: require("./firstLoginDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      scope: scope,
      controller: ["$scope", "user", function ($scope, user) {
        $scope.user = user;
      }],
      resolve: {
        user: function () {
          return user;
        }
      }
    });

    return modalInstance;
  }

  function showEmailDialog(scope, user, errorMessage) {
    var modalInstance = $uibModal.open({
      template: require("./emailDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      backdrop: "static",
      scope: scope,
      controller: ["$scope", "user", "errorMessage", function ($scope, user, errorMessage) {
        $scope.user = user;
        $scope.errorMessage = errorMessage;
      }],
      resolve: {
        user: function () {
          return user;
        },
        errorMessage: function () {
          return errorMessage;
        }
      }
    });

    return modalInstance;
  }
  function showBonusShopDialog(scope, user, DashboardService) {
    var modalInstance = $uibModal.open({
      template: require("./bonusShopDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      scope: scope,
      controller: ["$scope", "user", "DashboardService", function ($scope, user, DashboardService) {
        $scope.loading = true;
        $scope.user = user;
        $scope.fields = DashboardService.getBonusShopCardSelectionFields();
        $scope.loading = false;
        $scope.getData = (qo) => {
          return DashboardService.getBonusShopCardSelection().then((data) => {
            return data;
          });
        };
      }],
      resolve: {
        user: function () {
          return user;
        }
      }
    });

    return modalInstance;
  }

  function showVerifyContractDialog(scope, user, DashboardService) {
    var modalInstance = $uibModal.open({
      template: require("./verifyContractsDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      scope: scope,
      controller: ["$scope", "user", "DashboardService", function ($scope, user, DashboardService) {
        $scope.loading = true;
        $scope.user = user;
        $scope.fields = DashboardService.getContractVerificationFields();
        $scope.loading = false;

        $scope.getData = (qo) => {
          return DashboardService.getContractVerifications(qo).then((data) => {
            return data;
          });
        };
      }],
      resolve: {
        user: function () {
          return user;
        }
      }
    });

    return modalInstance;
  }

  function showConfirmChangeDialog(scope, confirmMessage, confirmMessageLink, contractlist, selectedContract, confirmButtonText) {
    var modalInstance = $uibModal.open({
      template: require("./confirmChangeDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      backdrop: "static",
      scope: scope,
      controller: ["$scope", "confirmMessage", "contractlist", "selectedContract", "confirmButtonText", function ($scope, confirmMessage, contractlist, selectedContract, confirmButtonText) {
        $scope.confirmMessage = confirmMessage;
        $scope.confirmMessageLink = '<a target="_blank" href="' + confirmMessageLink + '">' + confirmMessageLink + '</a>';
        $scope.contractlist = contractlist;
        $scope.selectedContract = selectedContract;
        $scope.confirmButtonText = confirmButtonText || "common.buttons.ok";
        $scope.selectItem = (selected) => {
          selected = selected || { value: undefined };

          if (selected.value !== $scope.selectedContract.id) {
            $scope.selectedContract.id = selected.value;
          }
        };

        if ($scope.selectedContract) {
          $scope.selectItem($scope.selectedContract);
        }

      }],
      resolve: {
        confirmMessage: function () {
          return confirmMessage;
        },
        confirmMessageLink: function () {
          return confirmMessageLink;
        },
        contractlist: function () {
          return contractlist;
        },
        selectedContract: function () {
          return selectedContract;
        },
        confirmButtonText: function () {
          return confirmButtonText;
        }
      }
    });

    return modalInstance;
  }

  function showProtectBuyTemplate(cardList, availableNumbers, additionalCardList, verifyProtectBuy, preSelectedPhone) {
    var modalInstance = $uibModal.open({
      //backdrop: "static",
      template: require("./protectBuyTemplate.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      backdrop: "static",
      controller: ["$scope", "$uibModalInstance", "cardList", "availableNumbers", "additionalCardList", "verifyProtectBuy", "preSelectedPhone",
        function ($scope, $uibModalInstance, cardList, availableNumbers, additionalCardList, verifyProtectBuy, preSelectedPhone) {
          $scope.loading = false;
          $scope.protectBuyEnabled = false; // Kann nur false sein sonst würd das PopUp garnicht kommen
          $scope.editMode = false;

          $scope.newPassword;
          $scope.chosenNumber = preSelectedPhone;
          //$scope.chosenNumber; // Wenn PB schon vorhanden ist sollte hier eine Nummer vorausgewählt sein!
          $scope.phoneValid;
          $scope.cardList = cardList;
          $scope.availableNumbers = availableNumbers;
          $scope.additionalCardList = additionalCardList;
          $scope.verifyProtectBuy = verifyProtectBuy;

          $scope.ok = function () {
            verifyProtectBuy($scope.chosenNumber, $scope.newPassword).then(() => {
              $uibModalInstance.close();
            });
          };

          $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
        }],
      resolve: {
        cardList: function () {
          return cardList;
        },
        availableNumbers: function () {
          return availableNumbers;
        },
        additionalCardList: function () {
          return additionalCardList;
        },
        verifyProtectBuy: function () {
          return verifyProtectBuy;
        },
        preSelectedPhone: function () {
          return preSelectedPhone;
        }
      }
    });

    return modalInstance;
  }

  function showKycJumpDialog(step, continueFunction, jumpFunction) {
    return $uibModal.open({
      template: require("./kycJumpDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      controller: ["$scope", "step", "continueFunction", "jumpFunction", function($scope, step, continueFunction, jumpFunction) {
        $scope.step = step;
        $scope.jumpToLabel = "kyc." + step.replace("-","") + ".header";
        $scope.continue = () => {
          continueFunction();
          $scope.$close();
        };
        $scope.jump = () => {
          jumpFunction();
          $scope.$close();
        };
      }],
      resolve: {
        step: function() {
          return step;
        },
        continueFunction: function() {
          return continueFunction;
        },
        jumpFunction: function() {
          return jumpFunction;
        }
      }
    });
  }

  function showKycSubmitDialog(
    cancelFunction,
    completeFunction,
    completePrintFunction
  ) {
    return $uibModal.open({
      template: require("./kycSubmitDialog.tpl.html"),
      windowTemplateUrl:
        "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      controller: [
        "$scope",
        "cancelFunction",
        "completeFunction",
        "completePrintFunction",
        function (
          $scope,
          cancelFunction,
          completeFunction,
          completePrintFunction
        ) {
          $scope.cancel = () => {
            cancelFunction();
            $scope.$close();
          };
          $scope.complete = () => {
            completeFunction();
            $scope.$close();
          };
          $scope.completePrint = () => {
            completePrintFunction();
            $scope.$close();
          };
        },
      ],
      resolve: {
        cancelFunction: function () {
          return cancelFunction;
        },
        completeFunction: function () {
          return completeFunction;
        },
        completePrintFunction: function () {
          return completePrintFunction;
        }
      },
    });
  }

  function showKycAdminStatusHistoryDialog(statusHistory) {
    return $uibModal.open({
      template: require("./kycAdminStatusHistoryDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      controller: ["$scope", "statusHistory", "LocaleService", function($scope, statusHistory, LocaleService){
        $scope.close = () => {
          $scope.$close();
        };
        $scope.statusHistory = statusHistory;
        let df1 = LocaleService.getDateFormat("mediumDateTime");
        $scope.formatDate = (date) => {
          // Transform Date from Mongo DB into UTC Date/Time...actually Mongo DB Times are in UTC
          // but not for KYC State Change Times...they are local! Easier to handle Sync from/to DOT
          return LocaleService.formatDate(moment.utc(date, "YYYY-MM-DD HH:mm:ss"), df1, true);
        };
      }],
      resolve: {
        statusHistory: function() {
          return statusHistory;
        }
      }
    });
  }

  function showKycAdminSubmitDialog(
    numItems,
    targetStatus,
    completeFunction,
    closeReasons,
    selectedReason
  ) {
    return $uibModal.open({
      template: require("./kycAdminActionConfirmationDialog.tpl.html"),
      windowTemplateUrl:
        "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      controller: [
        "$scope",
        "completeFunction",
        "numItems",
        "targetStatus",
        "closeReasons",
        "selectedReason",
        function (
          $scope,
          completeFunction,
          numItems,
          targetStatus,
          closeReasons,
          selectedReason
        ) {
          $scope.closeReasons = closeReasons;
          $scope.selectedReason = selectedReason;

          $scope.selectItem = (selected) => {
            selected = selected || undefined;

            if (selected !== $scope.selectedReason) {
              $scope.selectedReason = selected;
            }
          };

          if ($scope.selectedReason) {
            $scope.selectItem($scope.selectedReason);
          }

          $scope.cancel = () => {
            $scope.$close();
          };
          $scope.numItems = numItems;
          $scope.targetStatus = targetStatus;
          $scope.mustSelectReason = (targetStatus === "dot.syscodes.KDRST.KRSMR") && (closeReasons.length > 1);
          $scope.complete = () => {
            completeFunction();
            $scope.$close();
          };
        },
      ],
      resolve: {
        completeFunction: function () {
          return completeFunction;
        },
        numItems: function () {
          return numItems;
        },
        targetStatus: function () {
          return targetStatus;
        },
        closeReasons: function () {
          return closeReasons;
        },
        selectedReason: function () {
          return selectedReason;
        },
      },
    });
  }

  function showInfoDialog(scope, infoMessage, infoTitle) {
    var modalInstance = $uibModal.open({
      template: require("./infoDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope,
      controller: ["$scope", "infoMessage", "infoTitle", function ($scope, infoMessage, infoTitle) {
        $scope.infoMessage = infoMessage;
        $scope.infoTitle = infoTitle;
      }],
      resolve: {
        infoMessage: function () {
          return infoMessage;
        },
        infoTitle: function () {
          return infoTitle;
        }
      }
    });

    return modalInstance;
  }

  function showInputDialog(scope, dialogTitle, dialogMessage, dialogInfo, inputValue, saveRoutine, options) {
    options = options || {};
    var modalInstance = $uibModal.open({
      template: require("./inputDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      backdrop: "static",
      scope: scope,
      controller: ["$scope", "dialogTitle", "dialogMessage", "dialogInfo", "inputValue", "saveRoutine", "options", function ($scope, dialogTitle, dialogMessage, dialogInfo, inputValue, saveRoutine, options) {
        $scope.dialogMessage = dialogMessage;
        $scope.dialogTitle = dialogTitle;
        $scope.dialogInfo = dialogInfo;
        $scope.inputValue = inputValue;
        $scope.saveRoutine = saveRoutine;
        $scope.minlength = options.minlength;
        $scope.maxlength = options.maxlength;
        $scope.pattern = options.pattern;
        $scope.infotitle = options.infotitle;

        $scope.ok = function () {
          if ($scope.saveRoutine) {
            $scope.saveRoutine($scope.inputValue);
          }
          $scope.$close();
        };
      }],
      resolve: {
        dialogMessage: function () {
          return dialogMessage;
        },
        dialogInfo: function () {
          return dialogInfo;
        },
        dialogTitle: function () {
          return dialogTitle;
        },
        inputValue: function () {
          return inputValue;
        },
        saveRoutine: function () {
          return saveRoutine;
        },
        options: function () {
          return options;
        }
      }
    });

    return modalInstance;
  }

  function showSSMSDialog(scope, phoneNumber) {
    var modalInstance = $uibModal.open({
      template: require("./sSMSDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope,
      controller: ["$scope", "phoneNumber", function ($scope, phoneNumber) {
        $scope.phoneNumber = phoneNumber;
      }],
      resolve: {
        phoneNumber: function () {
          return phoneNumber;
        }
      }
    });

    return modalInstance;
  }

  function showAddPhoneDialog(scope, newPhone, sendTANfunction, verifyPhoneFunction, protectBuyEnabled, isUsedForProtectBuy) {
    // console.log("showAddPhoneDialog, PB", protectBuyEnabled);
    // protectBuyEnabled hat 3 Stati:
    // true => PB 2FA ist gesetzt, Telefonnr soll für Protect Buy 2FA verwendet werden
    // false => PB 2FA ist gesetzt, Telefonnr soll NICHT für Protect Buy 2FA verwendet werden
    // undefined => PB 2FA ist NICHT gesetzt
    // Wenn true oder false => Checkbox anzeigen; Wenn undefined => Checkbox nicht anzeigen
    var modalInstance = $uibModal.open({
      template: require("./confirmTANSMSDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      scope: scope,
      controller: ["$scope", "newPhone", "sendTANfunction", "verifyPhoneFunction", "protectBuyEnabled", "isUsedForProtectBuy", ($scope, newPhone, sendTANfunction, verifyPhoneFunction, protectBuyEnabled, isUsedForProtectBuy) => {
        $scope.newPhone = newPhone;
        $scope.sendTANfunction = sendTANfunction;
        $scope.verifyPhoneFunction = verifyPhoneFunction;
        $scope.protectBuyEnabled = protectBuyEnabled;
        $scope.isUsedForProtectBuy = isUsedForProtectBuy;
        $scope.TANsent = !(newPhone.id === "");
        $scope.focusTAN = $scope.TANsent;
        $scope.loading = false;
        $scope.protectBuyUsage = protectBuyEnabled || false;
        $scope.phoneDialogError = "";
        if (isUsedForProtectBuy) {
          $scope.dialogTitle = "confirmTANProtectBuy.title";
          $scope.dialogInfo = "confirmTANProtectBuy.info";
          //$scope.verificationError = "phoneNumbersProtectBuy.errors.verified";
        } else {
          $scope.dialogTitle = "confirmTANSMS.title";
          $scope.dialogInfo = "confirmTANSMS.info";
          //$scope.verificationError = "phoneNumbers.errors.verified";
        }

        $scope.toggleProtectBuy = () => {
          if (!$scope.TANsent) {
            $scope.protectBuyUsage = !$scope.protectBuyUsage;
          }
        };

        $scope.sendingTAN = (phoneId) => {
          $scope.loading = true;
          $scope.sendTANfunction(phoneId, $scope.protectBuyUsage).then((res) => {
            $scope.TANsent = true;
            $scope.phoneDialogError = "";
            $scope.loading = false;
            $scope.focusTAN = true;
          }, (err) => {
            $scope.TANsent = false;
            $scope.loading = false;
            $scope.focusTAN = false;
            if (_.get(err, "data.name") == "Error") {
              $scope.phoneDialogError = "phoneNumbers.errors.checkInputAlreadyUsed";
            }
            else {
              $scope.phoneDialogError = "phoneNumbers.errors.noTANsent";
            }
          });
        };

        $scope.verifyingPhone = (phoneId, TanCode, UseProtectBuy) => {
          $scope.loading = true;
          $scope.verifyPhoneFunction(phoneId, TanCode, UseProtectBuy).then(() => {
            $scope.loading = false;
            $scope.phoneDialogError = "";
            $scope.$close();
          }, (err) => {
            $scope.phoneDialogError = "phoneNumbers.errors.verified";
            $scope.loading = false;
          });
        };
      }],
      resolve: {
        newPhone: function () {
          return newPhone;
        },
        sendTANfunction: function () {
          return sendTANfunction;
        },
        verifyPhoneFunction: function () {
          return verifyPhoneFunction;
        },
        protectBuyEnabled: function () {
          return protectBuyEnabled;
        },
        isUsedForProtectBuy: function () {
          return isUsedForProtectBuy;
        }
      }
    });

    return modalInstance;
  }

  function showWelcomeDialog(scope) {
    var modalInstance = $uibModal.open({
      template: require("./welcomeDialog.tpl.html"),
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      scope: scope
    });

    return modalInstance;
  }

  function showDialog(template, controller, resolve, scope, backdrop) {

    var modalInstance = $uibModal.open({
      backdrop: backdrop || true,
      template: template,
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotification.tpl.html",
      controller: controller,
      resolve: resolve,
      keyboard: false,
      scope: scope
    });

    return modalInstance;
    /*modalInstance.result.then(function (selectedItem) {
        //$scope.selected = selectedItem;
    }, function () {
        //$log.info('Modal dismissed at: ' + new Date());
    });
    */
  }


  function showXLargeDialog(template, controller, resolve, scope) {

    var modalInstance = $uibModal.open({
      template: template,
      windowTemplateUrl: "modules/dc-ui/dc-modal/windowTemplateNotificationXLarge.tpl.html",
      controller: controller,
      resolve: resolve,
      keyboard: false,
      scope: scope
    });

    return modalInstance;

    /*modalInstance.result.then(function (selectedItem) {
     //$scope.selected = selectedItem;
     }, function () {
     //$log.info('Modal dismissed at: ' + new Date());
     });
     */

  }

  function closeAllDialogs() {
    $uibModalStack.dismissAll("Close all");
  }

}];



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-modal/DialogService.js